import { render, staticRenderFns } from "./InvoiceTradeInProductsForm.vue?vue&type=template&id=34fa537d"
import script from "./InvoiceTradeInProductsForm.vue?vue&type=script&lang=js"
export * from "./InvoiceTradeInProductsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports